import React, { Component, Fragment } from "react";
import { Link as LinkTo } from "react-router-dom";
import { AUTH_TOKEN, USER_ID } from "../constants";
import { timeDifferenceForDate, handleUnauthorized } from "../utils";
import { stripUrl, countRepliesRecursively, addUrlRefParam } from "../utils";
import { Mutation } from "react-apollo";
import gql from "graphql-tag";

const DELETE_MUTATION = gql`
  mutation DeleteMutation($linkId: ID!) {
    deleteLink(linkId: $linkId) {
      id
      postedBy {
        id
      }
    }
  }
`;

export const VOTE_MUTATION = gql`
  mutation VoteMutation($linkId: ID!) {
    vote(linkId: $linkId) {
      id
      link {
        id
        votes {
          id
          user {
            id
          }
        }
      }
      user {
        id
      }
    }
  }
`;

export const UNVOTE_MUTATION = gql`
  mutation UnVoteMutation($linkId: ID!) {
    unvote(linkId: $linkId) {
      id
      link {
        id
      }
    }
  }
`;

const userHasVoted = (link) => {
  const userId = localStorage.getItem(USER_ID);

  return !!link.votes.filter((vote) => {
    return vote.user && vote.user.id === userId;
  }).length;
};

class Link extends Component {
  state = {
    isVoting: false,
  };

  checkUnauthorized(error) {
    handleUnauthorized(error, this.props.history)
  }

  renderLinkUpVote = (authToken, votable, hasVoted, linkId) => {
    if (!authToken) {
      return (
        <LinkTo to="/login" className="no-underline">
          <div className="ml1 gray f11 upvote sg_upvote">▲</div>
        </LinkTo>
      );
    } else if (authToken && votable && hasVoted) {
      return (
        <Mutation
          mutation={VOTE_MUTATION}
          variables={{ linkId }}
          update={(store, { data }) => {
            this.setState({
              isVoting: false,
            });
            this.props.updateStoreAfterVote(store, data, this.props.link.id);
          }}
          onError={(err) => {
            this.checkUnauthorized(err)
            this.setState({
              isVoting: false,
            });
          }}
        >
          {(voteMutation) => (
            <div
              className="ml1 gray f11 upvote sg_upvote"
              onClick={() => {
                this.setState({
                  isVoting: true,
                });
                voteMutation();
              }}
            >
              {this.state.isVoting ? "" : "▲"}
            </div>
          )}
        </Mutation>
      );
    } else {
      return "";
    }
  };
  render() {
    const authToken = localStorage.getItem(AUTH_TOKEN);
    const userId = localStorage.getItem(USER_ID);
    const repliesCount = countRepliesRecursively(this.props.link.comments, 0);

    return (
      <div className="flex mt2 items-start">
        {!this.props.forAccountPage && (
          <div className="flex justify-between link-nr">
            <span className="gray">{this.props.index + 1}.</span>
            {this.renderLinkUpVote(
              authToken,
              this.props.votable,
              !userHasVoted(this.props.link),
              this.props.link.id
            )}
          </div>
        )}
        <div className="ml1">
          <a
            className={`link no-underline show-visited sg_link ${!this.props.forAccountPage &&
              this.props.link.postedBy &&
              this.props.link.postedBy.id === userId
              ? "my-link"
              : ""
              }`}
            href={addUrlRefParam(this.props.link.url)}
            target="_blank"
          >
            {this.props.link.description}{" "}
            <span className="f12 gray">({stripUrl(this.props.link.url)})</span>
          </a>
          <div className="f8pt lh-copy gray mt1 ls-m">
            {this.props.link.votes.length + 1}{" "}
            {this.props.link.votes.length + 1 === 1 ? "point" : "points"}
            {!this.props.forAccountPage && (
              <span>
                {" | by "}
                {this.props.link.postedBy ? (
                  <LinkTo
                    to={`/account/${this.props.link.postedBy.id}`}
                    className={`no-underline link sg_link-op ${this.props.link.postedBy.id === userId ? "green" : "gray"
                      }`}
                  >
                    {this.props.link.postedBy.name}
                  </LinkTo>
                ) : (
                    "Unknown"
                  )}
              </span>
            )}
            {" | "}
            {timeDifferenceForDate(this.props.link.created)}
            {" |"}
            <LinkTo
              to={`/link/${this.props.link.id}`}
              className="ml1 no-underline gray link sg_link-discuss"
            >
              {repliesCount > 0
                ? `${repliesCount} comment${repliesCount === 1 ? "" : "s"}`
                : "discuss"}
            </LinkTo>
            {authToken && this.props.votable && userHasVoted(this.props.link) && (
              <Mutation
                mutation={UNVOTE_MUTATION}
                variables={{ linkId: this.props.link.id }}
                update={(store, { data }) =>
                  this.props.updateStoreAfterVote(
                    store,
                    data,
                    this.props.link.id
                  )
                }
                onError={(err) => {
                  this.checkUnauthorized(err)
                }}
              >
                {(voteMutation) => (
                  <Fragment>
                    <span> |</span>
                    <span className="ml1 gray link" onClick={voteMutation}>
                      (unvote)
                    </span>
                  </Fragment>
                )}
              </Mutation>
            )}
            {authToken && this.props.deletable && (
              <Mutation
                mutation={DELETE_MUTATION}
                variables={{ linkId: this.props.link.id }}
                update={(store, { data }) =>
                  this.props.updateStoreAfterDelete(
                    store,
                    data,
                    this.props.link.id
                  )
                }
                onError={(err) => {
                  this.checkUnauthorized(err)
                }}
              >
                {(deleteMutation) => (
                  <Fragment>
                    <span> |</span>
                    <span className="ml1 gray link" onClick={deleteMutation}>
                      (delete)
                    </span>
                  </Fragment>
                )}
              </Mutation>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link.js